import i from"next/config";import{parseCommaSeparatedString as o}from"@grandvisionhq/state";const{publicRuntimeConfig:e}=i(),{ids:t,auth:r,preview:a}=e.googleTagManager,g={ids:o(t),auth:o(r),preview:o(a)};export{g};
//# sourceMappingURL=google-tag-manager-1fab6af4.js.map
